const Validation = (() => {
    const KeyPressException = ['email', 'password'];
    const _errormsgexception = ["ip_field", "confirmpassword", "password"];
    
    let UserProfile = (_obj) => {
        try {
            //console.log("Validation state",_obj);
            let __obj = Object.assign({}, _obj);
            let _res = Object.keys(__obj).map((x) => {
                let _field = __obj[x];
                if (_field.required)
                    _field.error = typeof _field.value === "string" ? _field.value.trim().length ? false : true : _field.value.length > 0 ? false : true
                if (!_field.error && _field.regexp)
                    _field.error = _completeValidation(_field);
                if (_field.type == "ip_field") {
                    let _ipres = _ipaddressValidation(_field);
                    _ipres.map((xx, ii) => {
                        if (typeof xx === "object") {
                            if (xx.includes(false)) {
                                _field.error = true;
                                _field.errormsg = "* Enter valid IP address/range";
                                return ii;
                            }
                        }
                        else {
                            _field.error = _field.error ? _field.error : !xx;
                            if (_field.error)
                                _field.errormsg = "* Enter valid IP address/range";
                        }
                    });
                    console.log(_ipres);
                    if (!_field.error) {
                        var _dup = [];
                        _field.value.map(xx => {
                            let _f = parseInt(xx.from.split(".")[3]); let _t = parseInt(xx.to.split(".")[3]);
                            let _ii = parseInt(_t) - parseInt(_f);
                            if (!isNaN(_ii)) {
                                for (var _i = _f; _i <= _t; _i++) {
                                    _dup.push(xx.from.split(".").slice(0, 3).join(".") + "." + _i)
                                }
                            }
                            else _dup.push(xx.from);
                            return;
                        });
                        if (_dup.length) {
                            (new Set(_dup).size === _dup.length) ? _field.error = false : _field.error = true;
                            if (_field.error)
                                _field.errormsg = "* IP Range already exist";
                        }
                    }
                }
                if (__obj["page_id"].edited === true && __obj["page_id"].value.length > 7) {
                    __obj["page_id"].error = true;

                }

                if (_field.type === "password" && __obj["confirmpassword"].show === true) {
                    if (_field.value.trim().length > 0) {
                        if (__obj["confirmpassword"].value.trim().length <= 0) {
                            __obj["confirmpassword"].error = true;
                            __obj["confirmpassword"].errormsg = "* Please enter the Confirm Password";
                        } else {
                            var _confirmvalue = __obj["confirmpassword"].value.trim();
                            if (_confirmvalue !== _field.value) {
                                __obj["confirmpassword"].error = true;
                                __obj["confirmpassword"].errormsg = "* Confirm Password do not match";
                            } else {
                                __obj["confirmpassword"].error = false;
                                __obj["confirmpassword"].errormsg = "";
                            }
                        }
                        if (_field.value.trim().length < 8 || !_regExpression("password").test(_field.value)) {
                            _field.error = true;
                            _field.errormsg = "* Password does not meet the policy";
                        }
                    }
                    else if (__obj["confirmpassword"].value.trim().length > 0) {
                        if (_field.value.trim().length <= 0) {
                            _field.error = true;
                            _field.errormsg = "* Please enter the Password";
                        }
                    }
                    //__obj["confirmpassword"].value
                }
                // Employee ID specific validation
                if (_field.regexp === "empid" && _field.value.length > 0) {
                    if (!_regExpression("empid").test(_field.value)) {
                        _field.error = true;
                        _field.errormsg = "* Employee ID is not valid.Allowed characters: letters (a-z, A-Z), digits (0-9), and special characters - _ ' @ . # ";
                    }
                }                
                if (_field.error && !_errormsgexception.includes(_field.type) && _field.regexp !== "empid")
                    _field.errormsg = _field.type === "text" ? "* Please enter a value" : "* Please select a value"
                return { [x]: _field }
            });
            // console.log(_res);
            return _obj;
        }
        catch (e) {
            console.log("Validation-->UserProfile", e);
        }
    }

    let _regExpression = _type => {
        const REGEXP = {
            "alphanumber": /^[0-9A-Za-z\s]*$/,
            "name": /^[0-9A-Za-z\s]?[^–]*$/,
            "number": /^[0-9]*$/,
            "ip": /^[0-9.]*$/,
            "phone": /^(\+?)[0-9 ?(0-9) ?\s-]*$/,
            "decimal": /^\d{0,9}(\.\d{0,2})?$/,
            //"decimal":/^[-+]?[0-9]+\.[0-9]+$/,
            "email": /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            "password": /^(?=.*)(?=.*[@#$%^&*/.])[a-zA-Z0-9@#$%^&*/.]{8,20}$/,
            // Employee id: letters, digits and - _ ' @ . #
            "empid": /^[a-zA-Z0-9\-_'@.#]+$/
        }
        return REGEXP[_type]
    }

    let _completeValidation = (_obj) => {
        //Check min and max length
        let _checkres = false;
        if (!_errormsgexception.includes(_obj.type)) {
            if (_obj.value.length > 0) {
                if (_obj.regexp === "phone") {
                    _obj.value = _obj.value.replace(/\D/g, "");
                }
                if ((_obj.value.length < _obj.minLength) || (_obj.value.length > _obj.maxLength)) {
                    _checkres = true;
                }
            }
            if (!_checkres && _obj.regexp) {
                // For Employee ID only: skip regex when empty (optional)
                if (_obj.regexp === "empid" && _obj.value.length === 0) {
                    _checkres = false; // no error
                } else {
                    _checkres = !KeyPress(false, _obj.regexp, _obj.value);
                }
            }
        }
        return _checkres;
    }

    let _ipaddressValidation = (_obj) => {  //Ip address basic and range validation input:obj,output array
        try {
            var ipregex = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/
            return _obj.value.map((x) => {
                if (x.to.length && !x.from.length) return false;
                if (x.from.length != 0) {
                    let _testfrom = ipregex.test(x.from)
                    let _testto = true;
                    if (x.to.length)
                        _testto = ipregex.test(x.to)

                    if (_testfrom && _testto) {
                        if (x.to.length) {
                            let _tolist = x.to.split(".");
                            return x.from.split(".").map((y, i) => {
                                let _res = parseInt(y, 10) - parseInt(_tolist[i], 10);
                                if (i != 3) { return (_res !== 0) ? false : true; }
                                else { return (_res > 0) ? false : true; }
                            });
                        } else return true;
                    } else return false;
                } else return true;
            });
        }
        catch (e) {
            console.log("Validation-->_ipaddressValidation", e);
        }
    }

    let KeyPress = (_key, _type, _value) => {
        try {
            let isValid = true;
            let _eliminate = _key ? (KeyPressException.indexOf(_type)) !== -1 ? 0 : -1 : -1;
            if (_type && _eliminate)
                isValid = _regExpression(_type).test(_value);
            return isValid;
        }
        catch (e) {
            console.log("Validation-->KeyPress", e);
        }
    }
    return {
        UserProfileValidation: UserProfile,
        KeyPressValidation: KeyPress,
        IPaddressValidation: _ipaddressValidation
    }
})();

export default Validation;